import {
    Component,
    effect,
    ElementRef,
    HostListener,
    inject,
    signal,
    Signal,
    viewChild,
    WritableSignal
} from '@angular/core';
import {TranslatePipe, TranslateService} from "@ngx-translate/core";
import {InputComponent} from "../../shared/form-elements/input/input/input.component";
import {translate} from "../../shared/translate/translate";
import {DatePipe, formatDate, NgClass} from "@angular/common";
import {LamelareaStore} from "../../shared/product-card/product-card/lamelarea.store";
import {ProjectStore} from "../../shared/store/project.store";
import {Router} from "@angular/router";

@Component({
  selector: 'app-save-component',
    imports: [
        TranslatePipe,
        InputComponent,
        NgClass
    ],
  templateUrl: './save-component.component.html',
  styleUrl: './save-component.component.scss'
})
export class SaveComponentComponent {
  protected translateService = inject(TranslateService);
  protected project: ProjectStore = inject(ProjectStore)
  protected lamellaAreaStore = inject(LamelareaStore);
  protected router = inject(Router);
  protected elementRef = inject(ElementRef);

  loading = signal(false);

  saves = this.project.saves;
  clickedIndex: WritableSignal<number> = signal(-1);
  clickedTimeout: any;
  clickedToClipboard = viewChild<ElementRef<HTMLDivElement>>('clickedToClipboard');

  toggleState= signal(false);
  dropDownRef = viewChild<ElementRef<HTMLDivElement>>('dropDown');

  projectName: WritableSignal<string> = signal("");
  projectPublic: WritableSignal<boolean> = signal(false);
  projectRecordName: WritableSignal<string> = signal("");
  projectRecordPublic: WritableSignal<boolean> = signal(false);

  projectNameKey: Signal<string> = translate("SAVE.PROJECT_NAME");
  projectRecordNameKey: Signal<string> = translate("SAVE.PROJECT_RECORD_NAME");

  constructor() {
    effect(() => { this.toggleState() && this.projectName.set(this.projectNameKey() + ' - ' + this.getLocalizedDateTime(Date.now()))});
    effect(() => { this.toggleState() && this.projectRecordName.set(this.projectRecordNameKey() + ' - ' + this.getLocalizedDateTime(Date.now()))});
  }

  @HostListener('document:click', ['$event'])
    handleClickOutside(event: Event): void {
        const targetElement = event.target as HTMLElement;
        if (this.toggleState() && !this.elementRef.nativeElement.contains(targetElement)) {
            this.toggleState.set(false);
            event.stopPropagation();
        }
    }


  getLocalizedDateTime(at: string|number|Date): string {
      try {
          return formatDate(at, 'short', this.translateService.getBrowserLang());
      } catch (er) {
          return formatDate(at, 'short', 'en_US');
      }
  }

  handleSave(){
       const project = this.project.provideProject( {name: this.project.name() ?? this.projectName(), isPublic: false } );
       const record = this.project.provideProjectRecord(this.projectRecordName());
       record.lamellaAreaGroups = this.lamellaAreaStore.getLamellaAreaGroups().map(g => ({...g, id: undefined}));
       project.projectRecords = [record];
       this.loading.set(true);
       if(this.project?.id()){
           this.project.saveNewProjectRecord(record).then( (save)=> {
               this.loading.set(false);
               this.lamellaAreaStore.setPristine();
           });
       }else {
           this.project.saveNewProject(project).then( (save)=> {
              this.loading.set(false);
               this.lamellaAreaStore.setPristine();
           });
       }


  }

  handleProjectReferenceRemoval(){
    if(confirm("Are you sure you want to remove current configuration from project reference?")) {
      this.project.clearProject();
    }
  }

  handleProjectRecordRemoval(){
      if(confirm("Are you sure you want to remove current configuration from project record?")) {
      this.project.clearProjectRecord();
      }
  }

  async copyToClipBoard(index: number, project: string, projectRecord: string){
    const url = window.location.href+`?project=${project}&projectRecord=${projectRecord}`;
    await navigator.clipboard.writeText(url);
    this.indexClicked(index);
  }

  indexClicked(index: number){
      if(this.clickedTimeout)clearTimeout(this.clickedTimeout);

      this.clickedIndex.set(index);

      new Promise(()=>{
          this.clickedTimeout = setTimeout(()=>{
              const resetIndex = ()=> {
                  this.clickedIndex.set(-1);
                  this.clickedToClipboard()?.nativeElement.removeEventListener('animationend', resetIndex);
              };

              this.clickedToClipboard().nativeElement.addEventListener('animationend', resetIndex, { once: true });
              this.clickedToClipboard().nativeElement.classList.add('animate-fade-out');
          }, 2000)
      });
  }


}
